import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.CALLS)({
    staticData: {
        config: {
            breadcrumb: { title: "calls", to: APP_ROUTES_TO.CALLS },
            title: "calls",
        },
        permissions: [PERMISSIONS.CALL_READ_CALLS],
    },
    component: CallsLayout,
});

function CallsLayout() {
    return <Outlet />;
}
